<div>
  <span> {{ (stoppedAt ? 'TIME.elapsed' : 'TIME.running') | translate }}:</span>
  @if (time.hours) {
    <span> {{ time.hours }}{{ 'TIME.hours_short' | translate }}</span>
  }
  @if (time.minutes) {
    <span> {{ time.minutes }}{{ 'TIME.minutes_short' | translate }}</span>
  }
  @if (time.seconds) {
    <span> {{ time.seconds }}{{ 'TIME.seconds_short' | translate }}</span>
  }
</div>
